import './App.css';
import Providers from "./navigation";
import React from "react";
import Footer from "./components/Footer";
import ErrorBoundary from "./components/ErrorBoundary";
import NetworkStatus from './components/NetworkStatus';
const App = () => {
    return (
        <ErrorBoundary>
            <NetworkStatus />
            <div className={"theme"}>
                <Providers />
            </div>
            <Footer>
                © 2024 BoozeOn. All rights reserved.
            </Footer>
        </ErrorBoundary>
    );
}

export default App;
